import React, { useState, useEffect } from 'react';
import slugify from 'slugify';
import { useLocation } from '@reach/router';

import './Tabs.scss';

function Tabs(props) {

  const { hash } = useLocation();

  let links = [];
  let sections = [];

  React.Children.map(props.children, child => {
    const slug = slugify(child.props.label, {lower: true});
    links.push({
      label: child.props.label,
      slug: slug
    });
    sections.push({
      id: slug,
      content: child.props.children
    });
  })

  const [activeTab, setActiveTab] = useState(links[0].slug);

  const changeActiveTab = (link, e) => {
    e.preventDefault();
    window.history.pushState({}, "", `#${link.slug}`)
    setActiveTab(link.slug);
  }

  useEffect(() => {
    // Remove "#" from the hash
    const slug = hash.substring(1);
    const doesSlugExists = links.find(link => link.slug === slug);

    if(doesSlugExists) setActiveTab(slug)
  }, [hash])

  return (
    <div className="Tabs">
      <TabsNavigation links={links} activeTab={activeTab} changeActiveTab={changeActiveTab} />
      {sections.map(section => {
        return (
          <div className={`Tab ${activeTab === section.id ? "TabSectionSelected" : ""}`} id={section.id}>
            {section.content}
          </div>
        )
      })}
    </div>
  );
}

function TabsNavigation ({links, activeTab, changeActiveTab}) {
  return (
    <nav className="TabsNav">
      <ul className="TabsNavList">
        {links.map(link => {
          return (
            <li key={link.slug}>
              <a href={`#${link.slug}`} className={activeTab === link.slug ? "TabsNavSelected" : null} onClick={(e) => changeActiveTab(link, e)}>
                {link.label}
              </a>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

function Tab(props) {
  return (
    <>
      {props.children}
    </>
  )
}



export default Object.assign(Tabs, {
  Tab
})
